module.exports = __webpack_public_path__ + "static/media/button-more-2.d13d8c6f.svg";